import React, { useState } from 'react';
import Button from "@mui/material/Button";
// import './Accordion.css'; // Add appropriate styles here



    const buttonStyles = {
    padding: '10px 30px',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.05em",
    border: "1px solid "
};

    // Define your date condition here
    const currentDate = new Date();
    const lastDisplayDate = new Date(2025, 11, 24, 23, 59, 59); // Example: Stop displaying after December 20, 2024

    // Combine the original showGlobalAccordion logic with the date condition
    const showGlobalAccordion = currentDate <= lastDisplayDate && true;
    // const showGlobalAccordion = true;
    const GlobalAccordion = ({ sectionTitle, items }) => {
    const [isActive, setIsActive] = useState(false);
    if (!showGlobalAccordion) {
    return null; // If showGlobalAccordion is false, don't render the banner
    }

    return (
        <div className="accordion bgRed">
            <div
                className="accordionTop accordionCenter bgRed"
                onClick={() => setIsActive(!isActive)}
            >
                <h2>Christmas Shipping Dates</h2>
                <div className="accordion-title bgRed">
                    <div className="accordionButton">{isActive ? '-' : '+'}</div>
                </div>
            </div>
            <div
                className={`accordionContent ${isActive ? 'open' : 'closed'}`}
                style={{
                    maxHeight: isActive ? '1900px' : '0',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease',
                }}
            >
                <div className="accordionSection">
                    <p>To ensure Santa’s little helpers have time to create your order<br/>please order before the
                        following


                        dates to ensure standard* pre-chrismas delivery.</p>
                    <div className="spacerSmall"/>

                    <p>*Express and next day will ship as normal.</p>

                    <div className="spacerSmall"/>
                    <h4>Jigsaw Puzzles:</h4>
                    <p><strong>UK:</strong> Order by the <strong>17th</strong> of December for pre-Christmas delivery.</p>
                    <p><strong>ROW:</strong> Order by the <strong>12th</strong> of December for pre-Christmas delivery.</p>
                    <div className="spacerSmall"/>
                    <h4>Cushions:</h4>
                    <p><strong>UK:</strong> Order by the <strong>17th</strong> of December for pre-Christmas delivery.</p>
                    <p><strong>ROW:</strong> Order by the <strong>10th</strong> of December for pre-Christmas delivery.</p>
                    <div className="spacerSmall"/>
                    <h4>Photo Books:</h4>
                    <p><strong>UK:</strong> Order by the <strong>12th</strong> of December for pre-Christmas delivery.</p>
                    <p><strong>ROW:</strong> Order by the <strong>8th</strong> of December for pre-Christmas delivery.</p>
                    <div className="spacerSmall"/>
                    <h4>Photo Tiles:</h4>
                    <p><strong>UK:</strong> Order by the <strong>16th</strong> of December for pre-Christmas delivery.</p>
                    <p><strong>ROW:</strong> Order by the <strong>14th</strong> of December for pre-Christmas delivery.</p>
                    <div className="spacerSmall"/>
                    <h4>Notebooks:</h4>
                    <p><strong>UK:</strong> Order by the <strong>16th</strong> of December for pre-Christmas delivery.</p>
                    <p><strong>ROW:</strong> Order by the <strong>12th</strong> of December for pre-Christmas delivery.</p>
                    <div className="spacerSmall"/>
                    <h4>Cards:</h4>
                    <p><strong>UK:</strong> Order by the <strong>17th</strong> of December for pre-Christmas delivery.</p>
                    <p><strong>ROW:</strong> Order by the <strong>12th</strong> of December for pre-Christmas delivery.</p>
                    <div className="spacerSmall"/>

                    <div className="spacerMed"/>

                    <Button style={buttonStyles} size="large" variant="outlined" href="/deliveries-and-returns">Read
                        more about delivery</Button>
                    <div className="spacerMed"/>

                </div>
            </div>
        </div>
    );
    };

export default GlobalAccordion;